import * as ActionTypes from './constants/ActionTypes';

const FORM_VALIDATION_ACTION_TYPES = [ActionTypes.INVALID_SUBMIT, ActionTypes.VALID_SUBMIT,
    ActionTypes.INVALIDATE_FORM, ActionTypes.VALIDATE_FORM];

export const logger = () => next => action => {
    /* eslint no-console: 0 */
    if (action && !(new RegExp(FORM_VALIDATION_ACTION_TYPES.join('|')).test(action.type))) {
        console.log('dispatching: ', action);
    }

    return next(action);
};



// WEBPACK FOOTER //
// ./src/middleware.js